import React from 'react'
import AssignZoneToMarketingExecutive from '../../features/admin/AssignZoneToMarketingExecutive'

const AssignZoneToMarketingExecutivePage = () => {
  return (
  <AssignZoneToMarketingExecutive role={"Marketing Executive"}/>
  )
}

export default AssignZoneToMarketingExecutivePage
